import React, { useEffect, useState } from 'react';
import { Button, Col, Spinner } from 'react-bootstrap';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import config from '../../../config/Constant';
import CustomAlert from '../../CustomAlert';
import { formatWithoutCurrency } from '../../../helpers/helperFunction';

const StripeMethod = ({ symbol, amountBeforeTax, amountAfterTax, accessToken, paymentIsLoadingFlag }) => {
  const [disableBtn, setDisableBtn] = useState(false);
  const [stripe, setStripe] = useState([]);
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  useEffect(() => {
    async function fetchConfig() {
      // Make sure to call `loadStripe` outside of a component’s render to avoid
      // recreating the `Stripe` object on every render.
      setStripe(await loadStripe(config.STRIPE_CLIENT));
    }
    fetchConfig();
  }, []);

  // change loading flag
  const handleBtnFlag = () => {
    setDisableBtn(false);
    paymentIsLoadingFlag(false);
  };

  // Fetch the transaction_id from backend
  const fetchCheckoutSession = async () => {
    setDisableBtn(true);
    paymentIsLoadingFlag(true);

    const data = {
      payment_gateway_id: config.payment_gateway.stripe.id,
      credit_amount: amountBeforeTax,
      total_tax: amountAfterTax,
    };

    return axios
      .post(`${config.urls.api_base_url}/payment`, data, {
        headers: {
          Authorization: accessToken,
        },
      })
      .then((res) => {
        const { error, message } = res.data;
        if (!error) {
          return res.data.data;
        }

        setAlertState({
          message: message,
          show: true,
          variant: 'danger',
        });
        return { transaction_id: null };
      })
      .catch(() => ({ transaction_id: null }));
  };

  const handleClick = async () => {
    // Call your backend to create the Checkout session.
    const { transaction_id } = await fetchCheckoutSession();

    if (transaction_id !== null) {
      // When the customer clicks on the button, redirect them to Checkout.
      const { error } = await stripe.redirectToCheckout({
        sessionId: transaction_id,
      });

      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `error.message`.
      if (error) {
        setAlertState({
          message: error.message,
          show: true,
          variant: 'danger',
        });
        // Disabled flag
        handleBtnFlag();
      }
    } else {
      setAlertState({
        message:
          'Something went wrong! Select credit package again and then click on Payment button.',
        show: true,
        variant: 'danger',
      });
      // Disabled flag
      handleBtnFlag();
    }
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div className="stripe-method d-flex justify-content-start align-items-center gap-1">
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Button
        type="submit"
        variant="primary"
        className="mb-3"
        disabled={disableBtn}
        onClick={handleClick}
        style={{ minWidth: 160 }}
      >
        {disableBtn && <Spinner animation="border" size="sm" className="mr-2" />}
        Pay Now
      </Button>
    </div>
  );
};

export default StripeMethod;
